import React, { Component } from "react";

import ContentLoader from "react-content-loader";
import LazyLoad from "react-lazyload";
import { NavLink } from "react-router-dom";
import Ink from "react-ink";
import axios from "axios";
import DelayLink from "../../../helpers/delayLink";
import Fade from "react-reveal/Fade";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import ProgressiveImage from "react-progressive-image";
import "slick-carousel/slick/slick-theme.css";
class SubSlider extends Component {
    state = {
        tags : [],
    };

    
    render() {

		return (
            <React.Fragment >
          
          {this.props.slides.length > 0 &&(
              <div className="scroll-items-parent ">
            {this.props.slides.map(tag => (
                    tag.type === this.props.type && (
                        <div className="scroll-item-slider" key={tag.id}>
                        <DelayLink  to={'/single-store-view-more/'+tag.item_group_id}>

                        <ProgressiveImage
						delay={100}
                        src={'https://pykin.in'+ tag.image}
						placeholder={'https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto/portal/m/blue_placeholder'}
					    >
						{(src, loading) => (
						 <img  style={{borderRadius: '6px'}} height={loading ? '195px' : this.props.height} width={this.props.width} src={src} alt={'pykin-fresh'}/>
						)}
					    </ProgressiveImage>	
                        </DelayLink>

                        </div>
                    )
                ))}
            </div>
            )}
            </React.Fragment>
        );
    }
}

export default SubSlider;